// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Hmm4aZ0kp7gi8DoB3lnA{display:grid;gap:12px;grid-template-columns:1fr 1fr 1fr 1fr}@media(min-width: 768px){.Hmm4aZ0kp7gi8DoB3lnA{grid-template-columns:1fr 1fr 1fr}}@media(min-width: 1024px){.Hmm4aZ0kp7gi8DoB3lnA{grid-template-columns:1fr 1fr 1fr 1fr}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardsContainer": "Hmm4aZ0kp7gi8DoB3lnA"
};
export default ___CSS_LOADER_EXPORT___;
